import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=562ab51c&"
import script from "./menu.ts?vue&type=script&lang=ts&"
export * from "./menu.ts?vue&type=script&lang=ts&"
import style0 from "./menu.scss?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports